import styled from 'styled-components';

import { VERTICAL_LIST_CAROUSEL_RANK_LIST_SECTION } from 'homepage/enums/contentConstants';
import { RankedOrPriceListCard } from 'homepage/components/verticalListCarouselSection/RankedOrPriceListCard';
import { hideScrollbars } from 'styles/utils/hideScrollbars';
import { variableFontRegular } from 'styles/theme/text';

export const ArticleTopShoesMobile = ({ results, title }) => {
  return (
    <ArticleTopShoesMobile.Wrapper>
      <ArticleTopShoesMobile.Title>{title}</ArticleTopShoesMobile.Title>
      {results.map((result, index: number) => (
        <RankedOrPriceListCard
          data={result}
          key={result.id}
          position={index + 1}
          type={VERTICAL_LIST_CAROUSEL_RANK_LIST_SECTION}
        />
      ))}
    </ArticleTopShoesMobile.Wrapper>
  );
};

ArticleTopShoesMobile.Wrapper = styled.div`
  align-items: center;
  aspect-ratio: 3/4;
  border: ${({ theme }) => theme.borders.black};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: auto;
  margin-right: 8px;
  overflow: scroll;
  padding: 24px 0;
  ${hideScrollbars};
`;

ArticleTopShoesMobile.Title = styled.div`
  font-weight: 600;
  position: sticky;
  text-align: center;
  text-decoration: underline;
  top: 0;
  ${variableFontRegular({ size: '11.5px', height: '14px' })};
`;
